import React, { useState, useEffect } from 'react';
import LoginPage from './components/LoginPage';
import Introduction from './components/Introduction';
import CaseStatus from './components/CaseStatus';
import CaseSummary from './components/CaseSummary';
import Strategy from './components/Strategy';
import ActionPlan from './components/ActionPlan';
import ContingencyPlan from './components/ContingencyPlan';
import Navbar from './components/Navbar';
import './App.css';
import { motion, AnimatePresence } from 'framer-motion';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State for menu blur
  const correctPassword = 'hunaincase515';

  useEffect(() => {
    const sessionAuth = sessionStorage.getItem('isAuthenticated');
    if (sessionAuth) {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (password) => {
    if (password === correctPassword) {
      sessionStorage.setItem('isAuthenticated', 'true');
      setIsAuthenticated(true);
    } else {
      alert('Incorrect Password');
    }
  };

  const MainContent = () => (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <Navbar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <main className={`main-content ${isMenuOpen ? 'blur' : ''}`}>
        <Introduction />
        <CaseStatus />
        <CaseSummary />
        <Strategy />
        <ActionPlan />
        <ContingencyPlan />
      </main>
      <footer style={{ textAlign: 'center', padding: '2rem', color: 'var(--slate)', fontFamily: 'monospace' }} className={isMenuOpen ? 'blur' : ''}>
        This is a living document and will be updated as the situation evolves.
      </footer>
    </motion.div>
  );

  return (
    <AnimatePresence>
      {!isAuthenticated ? (
        <LoginPage key="login" onLogin={handleLogin} />
      ) : (
        <MainContent key="content" />
      )}
    </AnimatePresence>
  );
}

export default App;